import { render, staticRenderFns } from "./CreditBooksType.vue?vue&type=template&id=8bb23dd0"
import script from "./CreditBooksType.vue?vue&type=script&lang=js"
export * from "./CreditBooksType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports